// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"562":"c277b050","896":"0402581e","985":"117bd8f6"}[chunkId] + ".chunk.js";
};